import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "../../components/Component";

const WorkExecutionAside = ({ updateSm, sm }: any) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const flowType = searchParams.get("flowType");
  const flowTypeQuery = flowType ? `?flowType=${flowType}` : "";

  // Get current pathname without query params for comparison
  const pathname = location.pathname;
  const pathWithoutPrefix = pathname.replace(process.env.PUBLIC_URL || "", "");

  // Helper function to check if a route is active
  const isActive = (route: string) => {
    const routePath = route.replace(process.env.PUBLIC_URL || "", "");
    // Exact match
    if (pathWithoutPrefix === routePath) return true;
    // For view pages with IDs, highlight the corresponding list page
    if (routePath === "/work-execution-under-execution" && 
        (pathWithoutPrefix.startsWith("/work-execution-view/") || 
         pathWithoutPrefix.startsWith("/work-execution-batch-details/") ||
         pathWithoutPrefix.startsWith("/work-execution-update/"))) return true;
    return false;
  };

  return (
    <div className="card-inner-group" style={{ minHeight: "90vh" }}>
      <div className="card-inner">
        <div className="user-card">
          <div className="user-info">
            <span className="lead-text">Work Execution</span>
            <span className="sub-text">
              Monitor and manage ongoing work executions and completions
            </span>
          </div>
        </div>
      </div>
      <div className="card-inner p-0">
        <ul className="link-list-menu">
          <li className={isActive(`${process.env.PUBLIC_URL}/work-execution-under-execution`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-under-execution${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="activity" />
              <span>Under Work Execution</span>
            </Link>
          </li>
          <li className={isActive(`${process.env.PUBLIC_URL}/work-execution-pending-approvals`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-pending-approvals${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-circle" />
              <span>Pending Approvals</span>
            </Link>
          </li>
          <li className={isActive(`${process.env.PUBLIC_URL}/work-execution-closed-works`) ? "active" : ""}>
            <Link
              to={`${process.env.PUBLIC_URL}/work-execution-closed-works${flowTypeQuery}`}
              onClick={() => updateSm(false)}
            >
              <Icon name="check-round" />
              <span>Closed Works</span>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default WorkExecutionAside;
